import { Component, OnInit } from '@angular/core';
import { TokenStorageService } from './_services/token-storage.service';
import {Router} from '@angular/router';
import {MenuItem} from 'primeng/api';
import {Globals} from "./globals";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  private roles: string[] = [];
  isLoggedIn = false;
  isAdmin = false;
  username: string = '';

  menuItemsUser: MenuItem[] = [];

  showProfileWin = false;
  showPasswordWin = false;

  copyrightYear = 2022;

  constructor(private tokenStorageService: TokenStorageService, private router: Router,
              private globals: Globals) {
  }

  ngOnInit(): void {
    this.copyrightYear = (new Date()).getFullYear();

    this.menuItemsUser  = [
      {
        label: 'User Profile',
        icon: 'pi pi-user-edit',
        command: () => {
          this.showProfileWin = !this.showProfileWin;
        }
      },
      {
        label: 'Change Password',
        icon: 'pi pi-key',
        command: () => {
          this.showPasswordWin = !this.showPasswordWin;
        }
      }
    ]

    this.isLoggedIn = !!this.tokenStorageService.getToken();

    if (this.isLoggedIn) {
      this.router.navigate(['tsaplus']);
      const user = this.tokenStorageService.getUser();
      this.roles = user.roles;

      this.isAdmin = this.roles.includes('TSA-ADMIN');
      let found = false;
      this.roles.forEach((item) => {
        if(item.startsWith('USER_') && !found) {
          found = true;
          this.globals.userGroup = item;
          this.menuItemsUser.push(      {
            label: 'Airport Grouping',
            icon: 'pi pi-tags',
            routerLink: 'admin'
          })
        }
      })

      this.username = user.username;
    } else {
      this.router.navigate(['tsa']);
    }
  }

  logout(): void {
    this.tokenStorageService.signOut();
    window.location.replace('/');
  }

  closePasswordWin(): void {
    this.showPasswordWin = false;
  }

  closeProfileWin(): void {
    this.showProfileWin = false;
  }
}
